import { Command } from '@/app/common/base/command'

export class SetDomainCommand extends Command {
    public async run(domain: string) {
        await this.store.dispatch('license/setDomain', domain)
    }
}
